import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subject, takeUntil } from 'rxjs';
import { SalesService } from 'src/app/services/api/sales.service';
import { DialogEgresoInsumoComponent } from '../dialog-egreso-insumo/dialog-egreso-insumo.component';
import {
  FileWithServicesAndMenu,
  GroupedFoodItemOutflow,
  GroupedServiceOutflow,
} from '../models';
import { EditObservacionComponent } from './edit-observacion/edit-observacion.component';
import { EditTotalPaxComponent } from './edit-total-pax/edit-total-pax.component';
import { ListaMultimediaComponent } from './lista-multimedia/lista-multimedia.component';

@Component({
  selector: 'app-table-expand',
  templateUrl: './table-expand.component.html',
  styleUrls: ['./table-expand.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableExpandComponent implements OnInit, OnDestroy {
  private _unsuscribeOnDestroy$: Subject<boolean> = new Subject<boolean>();
  @Input() fileServices: GroupedServiceOutflow[] = [];
  @Input() fileInsumos: GroupedFoodItemOutflow[] | null = [];
  @Input() file: FileWithServicesAndMenu | null = null;

  displayedColumns = [
    'day',
    'fechaServicio',
    'actividad',
    'servicio',
    'menu',
    'cantPAX',
    'tc',
    'totalGuiaAYB',
    'totalChoferAYB',
    'totalesPersonalCampoAYB',
    'totalMenuXFilaAYB',
    'observacionAYB',
    'asignar',
    'file',
  ];
  totalMenus = 0;
  dataSource: MatTableDataSource<GroupedServiceOutflow> =
    new MatTableDataSource();

  paginator!: MatPaginator;
  sort!: MatSort;

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.dataSource.paginator = this.paginator;
  }
  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.dataSource.sort = this.sort;
  }

  constructor(
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private readonly cdRef: ChangeDetectorRef,
    private readonly salesService: SalesService,
  ) {}

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource();
    this.dataSource.data = this.fileServices;
    this.handleTotalFiles();
  }

  ngOnDestroy(): void {
    this._unsuscribeOnDestroy$.next(true);
  }

  openDialogEditObservacion(serviceRow: GroupedServiceOutflow) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      accion: serviceRow.observacionAYB ? 'editar' : 'añadir',
      value: serviceRow.observacionAYB,
      data: serviceRow,
    };

    dialogConfig.width = '390px';
    dialogConfig.minHeight = '226px';
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(EditObservacionComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.success === true) {
        serviceRow.observacionAYB = result.observacionAYB;
      }
    });
  }
  openDialogEditTotalPax(elemento: any, columnName: string) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      value: elemento[columnName],
      data: elemento,
      columnName,
    };

    dialogConfig.width = '390px';
    dialogConfig.minHeight = '200px';
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(EditTotalPaxComponent, dialogConfig);

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsuscribeOnDestroy$))
      .subscribe((result) => {
        if (result) {
          if (result.success === true) {
            elemento[columnName] = Number(result.total);
            if (columnName !== 'totalMenuXFilaAYB') {
              elemento.totalMenuXFilaAYB =
                Number(elemento.totalesPersonalCampoAYB) +
                Number(elemento.cantPAX) +
                Number(elemento.tc) +
                Number(elemento.totalChoferAYB) +
                Number(elemento.totalGuiaAYB);
            }
            this.handleTotalFiles();
          }
        }
      });
  }

  handleTotalFiles() {
    this.totalMenus = this.fileServices.reduce(
      (sum, item) => sum + (item.totalMenuXFilaAYB ?? 0),
      0,
    );
    this.cdRef.markForCheck();
  }

  handleCero(value: any) {
    if (value === 0 || value === '0') {
      return '-';
    }
    return value;
  }

  openDialogInsumos(
    service: { miarchivo: SafeResourceUrl } & GroupedServiceOutflow,
  ) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      EDIT_FILE_OUTFLOWS: {
        file: this.file,
        currentService: service,
        foodItemsFromFile: this.fileInsumos,
      },
    };
    dialogConfig.panelClass = 'custom-dialog-class';
    dialogConfig.autoFocus = false;

    let dialogRef = this.dialog.open(DialogEgresoInsumoComponent, dialogConfig);

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsuscribeOnDestroy$))
      .subscribe(
        (result: {
          confirmInsumosAYB?: boolean;
          isthereChanges?: boolean;
          pdf?: string;
          success?: boolean;
        }) => {
          if (result.isthereChanges === true && result.success) {
            if (result.pdf) {
              service.miarchivo = this.getSafeUrl(result.pdf);
              service.confirmPDFAYB = true;
            }
            if (result.confirmInsumosAYB) {
              service.confirmInsumosAYB = result.confirmInsumosAYB;

              if (
                this.file != null &&
                this.dataSource.data.filter(
                  (d) => !d.confirmInsumosAYB && d.confirmInsumosAYB !== false,
                ).length === 0
              ) {
                this.salesService
                  .updateItinerary(this.file?.id ?? '', { egresoInsumos: true })
                  .pipe(takeUntil(this._unsuscribeOnDestroy$))
                  .subscribe({
                    next: (res) => {
                      if (this.file) {
                        this.file.egresoInsumos = true;
                      }
                    },
                    error: (err) => {},
                  });
              }
            }
          }
        },
      );
  }

  getSafeUrl(base64String: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(base64String);
  }
  openDialogMultimedia(serviceRow: GroupedServiceOutflow) {
    if (serviceRow.confirmPDFAYB) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        id: serviceRow.id,
      };
      dialogConfig.width = '780px';
      dialogConfig.minHeight = '220px';
      dialogConfig.panelClass = 'custom-dialog-class';
      dialogConfig.autoFocus = false;
      this.dialog.open(ListaMultimediaComponent, dialogConfig);
    }
  }
}
